import React from 'react';

import NotFound from 'components/errors/NotFound';

const NotFoundPage = () => <NotFound />;

export default NotFoundPage;
